function handlePlaceSelect(place) {
  // Initialize default values (empty string or null)
  let address = "";
  let state = { name: "", abbr: "" }; // State object with name and abbreviation
  let county = "";
  let unitNo = ""; // This might remain empty if no subpremise is provided.
  let city = "";
  let zipCode = "";
  // Check if address_components exist in the response
  if (place.address_components) {
    place.address_components.forEach((component) => {
      const types = component.types;
      // if street_number or route is present, we append the two values
      // if only 1 of them is present, we use that value
      // use short name for street_number and long name for route

      if (types.indexOf("street_number") > -1) {
        address = `${component.short_name}`;
      }

      if (types.indexOf("route") > -1) {
        address = `${address} ${component.long_name}`;
        address = address.trim(); // Remove any leading/trailing whitespace
      }

      // State is usually found in administrative_area_level_1
      if (types.indexOf("administrative_area_level_1") > -1) {
        // You may prefer the short_name (e.g., "PA") or long_name ("Pennsylvania") based on your UI needs.
        state = { name: component.long_name, abbr: component.short_name }; // or component.long_name;
      }

      // County is found in administrative_area_level_2
      if (types.indexOf("administrative_area_level_2") > -1) {
        county = component.long_name;
      }

      // City can sometimes be found in "locality" or "administrative_area_level_3"
      if (types.indexOf("locality") > -1) {
        city = component.long_name;
      } else if (types.indexOf("administrative_area_level_3") > -1 && !city) {
        // Fallback to administrative_area_level_3 if no locality is set
        city = component.long_name;
      }

      // Postal code is indicated by the "postal_code" type
      if (types.indexOf("postal_code") > -1) {
        zipCode = component.long_name;
      }

      // Unit number (apartment, suite, etc.) is indicated by "subpremise"
      if (types.indexOf("subpremise") > -1) {
        unitNo = component.long_name;
      }
    });
  }

  return {
    responseAddress: place.formatted_address || "",
    responseState: state || "",
    responseCounty: county || "",
    responseUnitNo: unitNo || "",
    responseCity: city || "",
    responseZipCode: zipCode || "",
    responseAddressLine: address || "",
  };
}

export { handlePlaceSelect };
